import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ModuleWithProviders } from '@angular/core';
import { AdminVaccineComponent } from './admin-vaccine.component';

const requestAppointmentRoutes: Routes = [
  { path: '', component: AdminVaccineComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(requestAppointmentRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class AdminVaccineRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/admin-vaccine/admin-vaccine.routing.ts